import React, { useEffect, useState } from "react";
import axios from "axios";
import { MdOutlineCheck } from "react-icons/md";
import "../assets/css/getQuoteSection.css";

const GetQuoteSection = () => {

    const backendUrl = process.env.REACT_APP_BACKEND_URI;

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        application: "",
        productName: "",
        message: ""
    });

    /* FETCH PRODUCTS ON LOAD */
    useEffect(() => {
        axios.get(`${backendUrl}/products`)
            .then(res => setProducts(res.data))
            .catch(() => console.error("Product fetch failed"));
    }, [backendUrl]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await axios.post(
                `${backendUrl}/api/quote`,
                {
                    name: form.name,
                    email: form.email,
                    mobile: form.phone,          // ✅ FIX
                    product: form.productName,   // ✅ FIX
                    application: form.application,
                    message: form.message,
                    countryCode: "+91"
                },
                { timeout: 15000 }
            );

            setShowSuccessModal(true);

            /* AUTO CLOSE MODAL AFTER 2 SECONDS */
            setTimeout(() => {
                setShowSuccessModal(false);
                setForm({
                    name: "",
                    email: "",
                    phone: "",
                    application: "",
                    productName: "",
                    message: ""
                });
            }, 2000);

        } catch (err) {
            alert("Failed to submit quote");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="quote-wrapper">

            {showSuccessModal && (
                <div className="quote-success-overlay">
                    <div className="quote-success-modal">
                        <h3>✅ Quote Submitted Successfully</h3>
                        <p>Our team will contact you shortly.</p>
                    </div>
                </div>
            )}

            <div className="quote-grid">

                {/* LEFT : FORM */}
                <form className="quote-form" onSubmit={handleSubmit}>
                    <span className="quote-tag">GET YOUR FREE ESTIMATE</span>
                    <h2>Get a Quote</h2>

                    <div className="form-grid">
                        <div className="form-group">
                            <label>Your name</label>
                            <input
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                placeholder="Your Name"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Email</label>
                            <input
                                name="email"
                                type="email"
                                value={form.email}
                                onChange={handleChange}
                                placeholder="Email"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Phone</label>
                            <input
                                name="phone"
                                value={form.phone}
                                onChange={handleChange}
                                placeholder="Phone"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Application / Industry Type</label>
                            <input
                                name="application"
                                value={form.application}
                                onChange={handleChange}
                                placeholder="Application / Industry"
                            />
                        </div>

                        <div className="form-group full">
                            <label>Choose a service</label>
                            <select
                                name="productName"
                                value={form.productName}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Product</option>

                                {products.map((product) => (
                                    <option key={product._id} value={product.title}>
                                        {product.title}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="form-note">
                        <input type="checkbox" id="gdpr-consent" className="checkbox-input" required />
                        <label htmlFor="gdpr-consent">
                            By submitting this form, you agree to the processing of your personal
                            data in accordance with the GDPR and our Privacy Policy.
                        </label>
                    </div>

                    <button className="primary-btn" disabled={loading} style={{ backgroundColor: '#fff', color: '#0f766e' }}>
                        <span className="btn-text-wrap">
                            <span className="btn-text">{loading ? "Submitting..." : "I'd Like a Quote"}</span>
                            <span className="btn-text btn-text-abs">{loading ? "Submitting..." : "I'd Like a Quote"}</span>
                        </span>
                    </button>
                </form>

                {/* RIGHT : IMAGE + CARD */}
                <div className="quote-right">
                    <div className="quote-image">
                        <img
                            src={require("../assets/images/Hero-Section-2-Image.png")}
                            alt="Lab"
                        />
                    </div>

                    <div className="quality-card">
                        <div className="quality-left">
                            <span className="quality-check"><MdOutlineCheck /></span>
                            <div>
                                <h4>100% Quality Assurance</h4>
                                <p>
                                    Your product quality is our top priority. Every batch of resin undergoes rigorous 
                                    testing to ensure consistency, bonding strength, and optimal performance.
                                </p>
                            </div>
                        </div>

                        <div className="quality-bubbles">
                            <img src={require('../assets/images/work-flow/bubble.png')} alt="" />
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default GetQuoteSection;
